/** Mode de calcul des RTT (paramètres de congés de l'entreprise). */
export enum RttMode {
  None = 0,
  FixedDays = 1,
  HoursAbove35 = 2,
  ForfaitJours = 3
}
